import { ReactNode } from 'react'
import { WorkItemAction } from '@fusion-advantage/formlib'
import { V2L1BobJobber } from '../../BobJobber/V2L1BobJobber'
import { V2L1ReasonableButton } from '../../Button/V2L1ReasonableButton'
import { faAlarmClock, faCircleCheck, faPlay, faVideoCamera } from '@fortawesome/pro-solid-svg-icons'
import { FusionColor } from '../../../../theme/FusionStyle'
import { V2L2BobJobberContext } from '../../BobJobber/V2L2BobJobberContext'

export enum ReminderState {
	Ready = 'ready',
	Loading = 'loading',
	Sent = 'sent',
}

interface V2L2VideoBobJobberProps {
	open: boolean
	canJoinVideo: boolean
	isJoiningVideo: boolean
	canStartForm: boolean
	canContinueForm: boolean
	canSendReminder: boolean
	reminderState: ReminderState
	onActionClick: (action: WorkItemAction) => void
	children?: ReactNode
}

export const V2L2VideoBobJobber = ({open, canJoinVideo, isJoiningVideo, canStartForm, canContinueForm, canSendReminder, reminderState, onActionClick, children}: V2L2VideoBobJobberProps) => {
	if(!canJoinVideo || !open) {
		return children
	}
	const jobber = (
		<V2L1BobJobber>
			<V2L1ReasonableButton
				icon={faVideoCamera}
				label="Join Video Call"
				onClick={(e) => {
					// prevent incrementBackgroundTaps
					// from closing the BobJobber immediately
					e.stopPropagation()
					onActionClick(WorkItemAction.JoinVideo)
				}}
				loading={isJoiningVideo}
				disabled={!canJoinVideo}
			/>
			{canStartForm ? (
				<V2L1ReasonableButton
					color={FusionColor.BlueMain}
					icon={faPlay}
					label="Start Form"
					onClick={() => onActionClick(WorkItemAction.StartEncounter)}
				/>
			) : null}
			{canContinueForm ? (
				<V2L1ReasonableButton
					color={FusionColor.BlueMain}
					icon={faPlay}
					label="Continue Form"
					onClick={() => onActionClick(WorkItemAction.ContinueForm)}
				/>
			) : null}
			<hr />
			<V2L1ReasonableButton
				color={FusionColor.White}
				icon={reminderState === ReminderState.Sent ? faCircleCheck : faAlarmClock}
				label={reminderState === ReminderState.Sent ? 'Reminder Sent' : 'Send Reminder'}
				onClick={(e) => {
					// prevent incrementBackgroundTaps
					// from closing the BobJobber immediately
					e.stopPropagation()
					onActionClick(WorkItemAction.SendReminder)
				}}
				loading={reminderState === ReminderState.Loading}
				disabled={!canSendReminder}
			/>
		</V2L1BobJobber>
	)
	return (
		<V2L2BobJobberContext jobber={jobber}>
			{children}
		</V2L2BobJobberContext>
	)
}
